import { useEffect } from 'react';
import { measureRtt } from '../../lib/ping';
import { useOverview } from '../../lib/live';
import { report } from '../../lib/telemetry';
import { useRoomSync } from '../../sync/roomStore';

// While a network capture runs (Settings → Network), every open app adds a probe every 15 s:
// HTTP round trips to the server (best / median of 3), the browser's own network estimate, and
// the sync channel's numbers when in a room. Logged as "probe" (category net).
export function useCaptureProbes() {
  const active = useOverview((s) => !!s.data?.capture);
  useEffect(() => {
    if (!active) return;
    let alive = true;
    const probe = async () => {
      const rtts = await measureRtt();
      if (!alive) return;
      const nav = (navigator as Navigator & { connection?: { type?: string; effectiveType?: string; downlink?: number; rtt?: number; saveData?: boolean } }).connection;
      const s = useRoomSync.getState();
      report(
        'info',
        'net',
        'probe',
        {
          httpBestMs: rtts.length ? Math.round(rtts[0]) : null,
          httpMedianMs: rtts.length ? Math.round(rtts[Math.floor(rtts.length / 2)]) : null,
          httpFailed: 3 - rtts.length || undefined,
          net: nav ? { type: nav.type, eff: nav.effectiveType, downMbps: nav.downlink, rttMs: nav.rtt, saveData: nav.saveData || undefined } : undefined,
          online: navigator.onLine,
          hidden: document.visibilityState === 'hidden' || undefined,
          room: s.roomId || undefined,
          sync: s.roomId ? { status: s.status, transport: s.transport, rttMs: Math.round(s.rtt * 10) / 10, minRttMs: Math.round(s.minRtt * 10) / 10, offsetMs: Math.round(s.offset * 10) / 10 } : undefined,
        },
        { dedupe: false },
      );
    };
    probe();
    const id = setInterval(probe, 15_000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, [active]);
}
